import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'hypecast-master-admin-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsComponent {
  mailTo(): void {}
}
